var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"peer-elephant",style:({
            'left': (this.currentX_ || this.targetX || 0 ) + 'px',
            'transform': 'scale(' + (this.flip == 'R' ? 1 : -1) + ', 1)',
            'visibility': this.walking ? 'visible' : 'hidden',
            'filter': 'hue-rotate('+ this.hue + 'deg)'
        }),attrs:{"src":require("../assets/elephant_walk.gif")}}),_c('img',{staticClass:"peer-elephant",style:({
            'left': (this.currentX_ || this.targetX || 0 ) + 'px',
            'transform': 'scale(' + (this.flip == 'R' ? 1 : -1) + ', 1)',
            'visibility': this.walking ? 'hidden' : 'visible',
            'filter': 'hue-rotate('+ this.hue + 'deg)'
        }),attrs:{"src":require("../assets/elephant_stand.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }